import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@front-activerse/common-components';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import type { UnifiedMealData } from '../types';
import { getTrackerMealPlaceholderImage } from '../helpers/trackerMealPlaceholder';

const DescribeManualMealContainer: React.FC<{ fromUserMeals?: boolean }> = ({ fromUserMeals }) => {
  const navigate = useNavigate();
  const {
    consts: { APP_BRAND },
  } = useAppContext();

  const PLACEHOLDER_IMAGE_URL = getTrackerMealPlaceholderImage(APP_BRAND as string);

  const createManualMealData = (dietMealId: number): UnifiedMealData => ({
    id: dietMealId,
    name: '',
    kcal: 0,
    macro: {
      protein: { grams: 0 },
      fat: { grams: 0 },
      carbohydrates: { grams: 0 },
    },
    preparationImageUrl: PLACEHOLDER_IMAGE_URL,
    sourceType: 'manual',
    ingredients: [],
    portions: 1,
    isFromBaseMeal: false,
  });

  useEffect(() => {
    sessionStorage.setItem('tracker_depth', '1');
    const dietMealId = Math.floor(Math.random() * 1000000000);
    const mealData = createManualMealData(dietMealId);

    if (fromUserMeals) {
      navigate(`/meals/user-meals/describe-meal/meal-details/${dietMealId}`, {
        state: { mealData, requestId: null, timestamp: Date.now() },
        replace: true,
      });
    } else {
      navigate(`/tracker/describe-meal/meal-details/${dietMealId}`, {
        state: { mealData, requestId: null, timestamp: Date.now() },
        replace: true,
      });
    }
  }, [navigate, fromUserMeals]);

  return <UniversalPlaceholder titleBar="tracker.logMeal.navbarTitle" />;
};

export default DescribeManualMealContainer;
